export default __webpack_public_path__ + "static/media/food1.3595b98e.jpg";